export type MiniappConnectionDiagnostic = {
  at: number;
  source: 'health' | 'api';
  summary: string;
  code?: string;
};

let lastDiagnostic: MiniappConnectionDiagnostic | null = null;

export function recordMiniappConnectionDiagnostic(
  entry: Omit<MiniappConnectionDiagnostic, 'at'>,
): void {
  lastDiagnostic = { ...entry, at: Date.now() };
  try {
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(
        'jester_last_connection_diagnostic',
        JSON.stringify(lastDiagnostic),
      );
    }
  } catch {}
}

export function peekMiniappConnectionDiagnostic(): MiniappConnectionDiagnostic | null {
  if (lastDiagnostic) return lastDiagnostic;
  try {
    const raw = window.sessionStorage.getItem('jester_last_connection_diagnostic');
    if (!raw) return null;
    const parsed = JSON.parse(raw) as MiniappConnectionDiagnostic;
    if (parsed?.summary && parsed?.source) {
      lastDiagnostic = parsed;
      return parsed;
    }
  } catch {}
  return null;
}
